module.exports = __webpack_public_path__ + "static/media/Head3.84ffa0fd.svg";